import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import Home from "./views/Home.vue";
import Template1 from "./components/Template1.vue";
import Template2 from "./components/Template2.vue";
import Template3 from "./components/Template3.vue";
import Template7 from "./components/Template7.vue";

Vue.use(Router);



const  scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition;
  }
  return { x: 0, y:0 };
}


export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: Home,
          name: 'Home',
        },
        {
          path: '/page1',
          component: Template1,
          name: 'Template1',
        },
        {
          path: '/page2',
          component: Template2,
          name: 'Template2',
        },
        {
          path: '/page3',
          component: Template3,
          name: 'Template3',
        },
        {
          path: '/page7',
          component: Template7,
          name: 'Template7',
        },
      ]
    },
  ],
  scrollBehavior,
});
